module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages"
  }, [_c('div', {
    staticClass: "error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      staticClass: "alert alert-danger alert-dismissible",
      attrs: {
        "track-by": "$index",
        "role": "alert"
      }
    }, [_vm._m(0, true), _vm._v("\n      " + _vm._s(_vm.$t(error)) + "\n    ")])
  })), _vm._v(" "), (_vm.warning) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v("\n      " + _vm._s(_vm.$t(_vm.warning)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v("\n      " + _vm._s(_vm.$t(_vm.info)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(3), _vm._v("\n      " + _vm._s(_vm.$t(_vm.success)) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b512e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
// module id = 306
// module chunks = 1